import { Component, Input, OnInit } from "@angular/core";
import { SharedServices } from '../../shared.service'; // ajusta la ruta si es necesario
import { Router } from "@angular/router";
import { MenuItem } from "src/app/interfaces/userLogin.interface";


@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html'
})


export class BottomNavComponent implements OnInit {
    userRole: string = '';
    selectedItem = '';
    accessList: string[] = [];
    private readonly roleAccessMap: Record<string, string[]> = {
        Distribuidor: [
            'Dashboard',
            'Productos',
            'Autorizaciones',
            'Pacientes',
            'VITALES_DISTRIBUIDOR',
            'RIPS',
            'PQR_ADMIN',
            'Mipres',
            'ONBOARDING_DISTRIBUIDOR',
            'WHATSAPP',
            'Integrations',
            'logistica',
            'eventos_Adversos',
            'informes',
        ],
        EPS: [
            'Dashboard_EPS',
            'Autorizaciones_EPS',
            'Pacientes_EPS',
            'VITALES_EPS',
            'informes',
        ],
        Paciente: [
            'Mis_Datos',
            'Autorizaciones_Pacientes',
            'PQR',
            'Preguntas_Frecuentes',
        ],
        PQRs: ['PQR_ADMIN'],
        LAB: ['Dashboard_LAB', 'Autorizaciones_LAB', 'VITALES_LAB', 'informes'],
    };
    navItems: MenuItem[] = []
    activeSubmenuItem: any = null;

    constructor(
        private sharedService: SharedServices,
        private router: Router,
    ) {
        this.navItems = this.sharedService.userLogin.menu
    }


    ngOnInit(): void {
        this.userRole = this.sharedService.userLogin.rol;
        this.accessList = this.roleAccessMap[this.userRole] || [];
        this.filterNavItems();

    }

    filterNavItems() {
        this.navItems = this.navItems.filter((item) =>
            this.accessList.includes(item.moduleKey),
        );
    }

    // toggleSubmenu(item: any) {
    //     if (this.activeSubmenuItem === item) {
    //         this.activeSubmenuItem = null;
    //     } else {
    //         this.activeSubmenuItem = item.submenu ? item : null;
    //     }
    // }

    toggleSubmenu(item: any) {
        this.selectedItem = item.moduleKey;

        if (item.subMenu?.length) {
            const isSame = this.activeSubmenuItem?.moduleKey === item.moduleKey;

            this.activeSubmenuItem = isSame ? null : item;
        } else {
            this.navigateTo(item);
        }
    }
    navigateTo(item: any) {
        if (item.label === 'Cerrar sesión') {
            localStorage.clear();
            this.router.navigateByUrl('/login');
            return;
        }

        this.router.navigateByUrl(item.url);
        this.activeSubmenuItem = null;
    }
}
